// extracted by mini-css-extract-plugin
module.exports = {"container":"MiniMenu_container__70W6G","item":"MiniMenu_item__t_NlD","image":"MiniMenu_image__pTQB0","name":"MiniMenu_name__evqQR","arrow":"MiniMenu_arrow___zVQU"};